import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";

function LevelPill({ level, inlineDescription = false }) {
  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "baseline",
        gap: 0.5,
        px: 1,
        py: 0.25,
        borderRadius: "9999px",
        bgcolor: (theme) => alpha(theme.palette.primary.main, 0.1),
        color: "text.primary",
        fontSize: "0.75rem",
        lineHeight: 1.4,
        maxWidth: "100%"
      }}
    >
      {level.sportName && (
        <Box component="span" sx={{ fontWeight: 700 }}>
          {level.sportName}
        </Box>
      )}
      <Box
        component="span"
        sx={{ color: "text.secondary", minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: { xs: "normal", sm: "nowrap" } }}
      >
        {`Level ${level.levelValue}${level.levelName ? ` · ${level.levelName}` : ""}`}
        {inlineDescription && level.description && (
          <Box component="span" sx={{ color: "primary.dark", fontWeight: 700 }}>
            {` · ${level.description}`}
          </Box>
        )}
      </Box>
    </Box>
  );
}

// The club's level description says who a level is for (kids/adults, ages),
// which the level name alone often doesn't.
function ClientLevelPills({ levels, withDescriptions = false, sx }) {
  if (!levels?.length) {
    return (
      <Typography variant="caption" sx={{ color: "text.disabled", ...sx }}>
        No level set
      </Typography>
    );
  }

  const keyOf = (l) => `${l.sportId}:${l.levelValue}`;

  if (withDescriptions && levels.some((l) => l.description)) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 0.75, ...sx }}>
        {levels.map((l) => (
          <Box key={keyOf(l)} sx={{ maxWidth: "100%" }}>
            <LevelPill level={l} />
            {l.description && (
              <Typography
                variant="caption"
                component="div"
                sx={{
                  mt: 0.25,
                  pl: 1,
                  color: "text.secondary",
                  whiteSpace: "normal",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden"
                }}
              >
                {l.description}
              </Typography>
            )}
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, ...sx }}>
      {levels.map((l) => (
        <LevelPill key={keyOf(l)} level={l} inlineDescription />
      ))}
    </Box>
  );
}

export default ClientLevelPills;
